import { useEffect, useState } from 'react';
import { StatisticsWidget } from '~/components/common/statistics-widget';
import { RecentProducts } from './recent-products.table';
import { SalesChart } from './sales.chart';
import { useTranslate, Translate } from '~/i18n';
import ProductsBarChart from '~/components/completed-dashboard/products.chart';
import PieChart from '~/components/completed-dashboard/payout-pie.chart';
import useOverallStatistics from '~/apis/dashboard-statistics/useOverallStatistics';
// import HelpCenter from './help-center';
import OnboardingModal from '~/components/incomplete-dashboard/onboard/onboarding-modal';
import useUserProfile from '~/apis/useUserProfile';
import { useAuth } from '~/auth';
import BnplInfoCard from '~/components/bnpl/bnpl-info-card';
import useBnplStatus from '~/apis/bnpl/useBnplStatus';

export const CompletedDashboard = () => {
   const { translate } = useTranslate();
   const { data: overall } = useOverallStatistics();

   const { user, updateUser } = useAuth();
   const { data: userProfileData, refetch: refetchUser } = useUserProfile({
      onSuccess: data => {
         if (data && data.status) {
            updateUser({ ...user, ...data });
         }
      },
   });

   const { data: bnplStatusData, refetch: refetchBnplStatus } = useBnplStatus();

   const [openOnboardingModal, setOpenOnboardingModal] = useState(true);
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [_, setOpenSkipOnboarding] = useState(false);

   useEffect(() => {
      refetchBnplStatus();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [user]);

   return (
      <div className="p-5">
         {!userProfileData?.uploaded_legal_docs && (
            <div
               className={
                  'p-6 mb-5 rounded-md text-sm border-[#646EC866] border bg-[rgba(255,209,121,0.5)] flex items-center flex-wrap gap-4 justify-between'
               }>
               <div className="flex flex-col gap-1">
                  <span className="font-semibold">
                     <Translate id="common:hello" />, {user?.current_user?.name || ''}
                  </span>
                  <Translate id="profile:please upload your documents" />
               </div>
               <button
                  onClick={() => {
                     setOpenOnboardingModal(true);
                  }}
                  className="px-4 py-2 font-semibold bg-transparent border rounded-md border-grey-200 disabled:cursor-not-allowed">
                  <Translate id="profile:complete your account" />
               </button>
            </div>
         )}

         {bnplStatusData?.bnplSupport && !bnplStatusData?.isBnplEnabled ? (
            <div className="mb-7">
               <BnplInfoCard
                  isBnplActive={bnplStatusData?.isBnplEnabled}
                  refetchBnplStatus={refetchBnplStatus}
                  tabbyServiceRate={bnplStatusData?.tabby_service_rate}
                  tamaraServiceRate={bnplStatusData?.tamara_service_rate}
               />
            </div>
         ) : null}

         <div className="grid grid-cols-5 gap-7 mb-7">
            <div className="grid grid-cols-2 col-span-5 gap-4 text-center md:grid-cols-3 lg:grid-cols-4 ">
               <StatisticsWidget
                  icon="/icons/equalizer.svg"
                  title={translate({ id: 'dashboard:total sales' })}
                  count={overall?.data?.total_sales}
                  isCurrency
               />
               <StatisticsWidget
                  icon="/icons/voucher.svg"
                  title={translate({ id: 'dashboard:total orders sold' })}
                  count={overall?.data?.total_bookings_sold}
               />
               <StatisticsWidget
                  icon="/icons/balance.svg"
                  title={translate({ id: 'dashboard:available for payout' })}
                  count={overall?.data?.total_available_for_payout}
                  isCurrency>
                  {/* {overall?.data?.show_create_claim_button && (
                     <button
                        onClick={() => router.push(`/${lang}/profile/business/payout`)}
                        className="px-4 py-1 text-xs text-white rounded-md bg-primary disabled:bg-gray-500 disabled:cursor-not-allowed ">
                        <Translate id="payout:request payout" />
                     </button>
                     // <button
                     //    onClick={() => router.push(`/${lang}/profile/business/payout`)}
                     //    disabled={!overall?.data?.show_create_claim_button}
                     //    className="px-4 py-1 text-xs text-white rounded-md bg-primary disabled:bg-gray-500 disabled:cursor-not-allowed ">
                     //    <Translate id="payout:request payout" />
                     // </button>
                  )} */}
               </StatisticsWidget>
               {/* <StatisticsWidget
                  icon="/icons/payout.svg"
                  title={translate({ id: 'dashboard:wallet balance' })}
                  count={userProfileData?.wallet_balance}
                  isCurrency></StatisticsWidget> */}
               <StatisticsWidget
                  icon="/icons/star.svg"
                  title={`${translate({ id: 'dashboard:NPS score' })} (${translate({
                     id: 'common:coming soon',
                  })})`}
                  count={overall?.data?.nps_score}
               />
            </div>
            <div className="col-span-5 lg:col-span-3">
               <SalesChart />
            </div>
            <div className="col-span-5 lg:col-span-2">
               <ProductsBarChart />
            </div>
            <div className="col-span-5 ">
               <div className="grid gap-6 grid-col-1 lg:grid-cols-2">
                  <div className="col-span-1 ">
                     <PieChart />
                  </div>
                  <div className="col-span-1">
                     <RecentProducts />
                  </div>
               </div>
            </div>
            <div className="col-span-5">
               {/* <HelpCenter /> */}
               {/* <NewHelpCenter /> */}
            </div>
            {!userProfileData?.uploaded_legal_docs && (
               <OnboardingModal
                  open={openOnboardingModal}
                  setOpen={setOpenOnboardingModal}
                  setOpenSkipOnboarding={setOpenSkipOnboarding}
                  refetchUser={refetchUser}
               />
            )}
         </div>
      </div>
   );
};
